import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveReportTemplateType } from './reportTemplateTypeActions';
import { GetReportTemplateType } from './reportTemplateTypeTypes';

// Api's
import { reportTemplateTypeApi } from '../../api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getReportTemplateTypeSaga(action: GetReportTemplateType) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      reportTemplateTypeApi.getDomain
    );
    if (response.data.result) {
      yield put(
        saveReportTemplateType(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveReportTemplateType(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

